import React, { useMemo, useState } from 'react';
import { Input, Spin } from 'antd';
import { isEmpty, filter } from 'lodash';

import './SearchStops.scss';
import Icons from '../../icons';

const SearchStops = ({ stops, onClickStop }) => {
  const [searchValue, setSearchValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickStop = (stop) => {
    onClickStop(stop);
    setSearchValue('');
  };

  const searchedStops = useMemo(() => {
    if (!isEmpty(searchValue)) {
      const stopsT = filter(stops, (o) => {
        return (
          o.address?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.driverName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.name?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.orderCode?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.partner?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.volume?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
      return stopsT;
    } else {
      return [];
    }
  }, [searchValue, stops]);

  const handleOnSearch = (e) => {
    setLoading(true);
    setTimeout(() => {
      setSearchValue(e.target.value);
      setLoading(false);
    }, 100);
  };

  return (
    <div className="SearchStops">
      <div className="SearchBox">
        <Input.Search allowClear placeholder="Search stop" onChange={handleOnSearch} value={searchValue} />
      </div>
      {!isEmpty(searchValue) && searchedStops?.length > 0 && (
        <Spin spinning={loading}>
          <div className="StopsList">
            <div className="Title">{searchedStops?.length} stops found</div>
            {searchedStops.map((stop, index) => {
              const status = stop?.status;
              const driverName = stop?.driverName ?? 'Driver';
              return (
                <div
                  key={index + (stop.id || stop.orderIds?.[0] || stop.orderId)}
                  className="StopItem order-popup"
                  onClick={() => handleClickStop(stop)}
                >
                  <div className="header">
                    <div className="left">
                      <div
                        className={`type ${stop.type.toLowerCase()}`}
                        style={{
                          border: `1px solid ${stop.color}`,
                          color: `${stop.color}`,
                        }}
                      >
                        {stop.index}
                      </div>
                      {stop.orderCode}
                    </div>
                    <div className="right">
                      <Icons type="InfoWindowCar" className="info-icon" color={stop.color} />
                      {driverName && <div className="driverInfo">{driverName}</div>}
                    </div>
                  </div>
                  <div className="content-top">
                    <span className={`status orderStatus ${status?.code?.toLowerCase()}`}>{status?.name}</span>
                    <div className="name">{stop.name}</div>
                  </div>
                  <div className="content-address">{stop.address}</div>
                </div>
              );
            })}
          </div>
        </Spin>
      )}
    </div>
  );
};

export default SearchStops;
